

import React, { useRef, useState, useContext } from 'react';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { classNames } from 'primereact/utils';
import { Checkbox } from 'primereact/checkbox';
import { ColorPicker } from 'primereact/colorpicker';

import axios from '../axios';
import { useFormik } from 'formik';
import AppContext from '../Context/AppContext';
import Modal from '../Widgets/Modal';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from 'primereact/dropdown';
import { useMountEffect } from 'primereact/hooks';
import { InputNumber } from 'primereact/inputnumber';

const ListAddModal = ({ hide, update }) => {
    const existingNames = useRef([])
    const { sendMessage, toast, setBlocked } = useContext(AppContext)

    const [visible, setVisible] = useState(true)

    const formik = useFormik({
        initialValues: {
            name: "",
            clearstream_list_id: "",
        },
        validate: (data) => {
            let errors = {};
            if (!data.name) {
                errors.name = 'Name is required';
            }
            else if (data.name.length < 2) {
                errors.name = 'Name must have at least 2 letters'
            }
            else if (data.name.length > 15) {
                errors.name = 'Name must be not longer than 15 letters'
            }
            else if (existingNames.current.some(item => item.toLowerCase() === data.name.toLowerCase())) {
                errors.name = 'Name already exists in the database'
            }

            return errors;
        },
        onSubmit: async (data) => {
            setBlocked(true)
            try {
                const response = await axios.get('/contacts/check_list', { params: { name: data.name } });
                if (response.data.success) {
                    existingNames.current = [...existingNames.current, ...response.data.data]
                    formik.validateForm()
                    setBlocked(false)
                    return
                }
            }
            catch (error) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to connect!', life: 3000 });
                setBlocked(false)
                return
            }

            try {
                const response = await axios.post('/contacts/add_list', data);
                if (response.data.success) {
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: `List ${data.name} added!`, life: 3000 });
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to add list!', life: 3000 });
                }
            }
            catch (error) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to add list!', life: 3000 });
            }

            setBlocked(false)
            update()
            sendMessage(JSON.stringify({ type: "lists_added" }))
            setVisible(false)
        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    const footer = (
        <React.Fragment>
            <Button label="Cancel" icon="pi pi-times" outlined onClick={() => { setVisible(false) }} />
            <Button label="Save" icon="pi pi-check" className="m-0" type='submit' form='submit-list' />
        </React.Fragment>
    );

    return (
        <Modal header="Add List" visible={visible} onHide={() => setVisible(false)} transitionOptions={{ onExited: () => hide() }} footer={footer}>
            <form onSubmit={formik.handleSubmit} id='submit-list' className='formgrid grid'>
                <div className="field col-12">
                    <label htmlFor="name">Name</label>
                    <InputText name='name' id='name' value={formik.values.name} onChange={formik.handleChange} className={classNames('w-full', { 'p-invalid': isFormFieldValid('name') })} autoFocus />
                    {getFormErrorMessage('name')}
                </div>

                <div className="field col-12">
                    <label htmlFor="clearstream_list_id">Clearstream List ID</label>
                    <InputText name='clearstream_list_id' id='clearstream_list_id' value={formik.values.clearstream_list_id} onChange={formik.handleChange} className={classNames('w-full', { 'p-invalid': isFormFieldValid('clearstream_list_id') })} />
                    {getFormErrorMessage('clearstream_list_id')}
                </div>
            </form>
        </Modal>
    );
}

export default ListAddModal;